import { render, staticRenderFns } from "./BaseModalContainer.vue?vue&type=template&id=3f620aa7&scoped=true&"
var script = {}
import style0 from "./BaseModalContainer.vue?vue&type=style&index=0&id=3f620aa7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f620aa7",
  null
  
)

export default component.exports